import {
  AvailabilityStatus,
  MecProduct,
} from '@adapters/bigcommerce/types/product';

export const isCompareProductAvailable = (
  product: MecProduct | null | undefined
): boolean => {
  if (!product) return true;

  if (product.isDisabled === true) return false;
  if (product.isVisible === false) return false;
  if (product.isInStock === false) return false;
  if (product.availableForSaleOnline === false) return false;
  if (product.availabilityStatus === AvailabilityStatus.unavailable)
    return false;

  return true;
};
